<script>
    export let items = [];
    export let activeTabValue = 1;
  
    const handleClick = tabValue => () => (activeTabValue = tabValue);
  </script>
  
  <ul class="ul-tab">
  {#each items as item}
      <li class={activeTabValue === item.value ? 'active' : ''}>
          <span  class= "span-tab" on:click={handleClick(item.value)}>{item.label}</span>
      </li>
  {/each}
  </ul>
  {#each items as item}
      {#if activeTabValue == item.value}
      <div class="box">
          <svelte:component this={item.component}/>
      </div>
      {/if}
  {/each}
  <style>

  </style>